module.exports = __webpack_public_path__ + "media/images/convenios/cofeocor-d706539adcfcc8ccc8a1af8c5e14ccea.jpg";